import type { PlatformPlanId } from './db/types';

export type MenuFeature =
  | 'dashboard'
  | 'checkin'
  | 'members'
  | 'waivers'
  | 'invoices'
  | 'reports'
  | 'appointments'
  | 'services'
  | 'plans'
  | 'website'
  | 'users'
  | 'settings'
  | 'leads';

const planRank: Record<PlatformPlanId, number> = {
  core: 0,
  pro: 1,
  command: 2,
};

export const menuFeaturePlanMap: Record<MenuFeature, PlatformPlanId> = {
  dashboard: 'core',
  checkin: 'core',
  members: 'core',
  waivers: 'core',
  invoices: 'core',
  reports: 'core',
  appointments: 'core',
  services: 'core',
  plans: 'core',
  website: 'core',
  users: 'core',
  settings: 'core',
  leads: 'pro',
};

export function normalizePlatformPlanId(planId?: string | null): PlatformPlanId {
  if (planId === 'pro' || planId === 'command') {
    return planId;
  }

  return 'core';
}

export function canAccessMenuFeature(planId: string | null | undefined, feature: MenuFeature): boolean {
  const normalizedPlanId = normalizePlatformPlanId(planId);
  const requiredPlanId = menuFeaturePlanMap[feature];
  return planRank[normalizedPlanId] >= planRank[requiredPlanId];
}
